import React from "react";

import englishFlag from "../../assets/images/english-flag.svg";
import portugueseFlag from "../../assets/images/port-flag.svg";

import styles from "../../assets/styles/language.module.scss";

interface ILanguageProps {
  value: string;
  onClick: () => void;
  className?: string;
}

export function Language(props: ILanguageProps) {
  return (
    <div className={`d-flex justify-content-center ${styles.flagContainer} ${props.className}`}>
      <a onClick={props.onClick}>
        <img
          src={props.value == "en" ? portugueseFlag : englishFlag}
          alt={props.value == "en" ? "Mudar para português" : "Change to english"}
          height="25"
          width="25"
        />
      </a>
    </div>
  );
}